module.exports = __webpack_public_path__ + "img/ico_zoomin.f77a769a.png";